// In-place navigation for links whose address only exists in Alpine state
// (`:href` inside x-for rows), which htmx never processes. Modifier and
// non-left clicks fall through to the browser so "open in new tab" works.

export function isPlainLeftClick(e: MouseEvent): boolean {
    return e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey;
}

export function navigateMain(e: MouseEvent, href: string): void {
    if (!isPlainLeftClick(e)) return;
    e.preventDefault();
    // htmx compares push against the string 'true' (the server's final URL);
    // a boolean true would be pushed literally as the URL "true". The cast is
    // needed because htmx.ajax's typings do not declare `push`.
    window.htmx.ajax("GET", href, { target: "#main-content", push: "true" } as any);
}
